<template>
  <b-modal
    :id="`modal-alert-rule-branch-${branchData.branchId}`"
    :title="
      this.$t('menu.settings.alertsNewsletters.ruleBranch', {
        branchDataName: `${branchData.name}`,
      })
    "
    size="xl"
    :ok-title="`${this.$t('menu.settings.alertsNewsletters.save')}`"
    :cancel-title="`${this.$t('menu.settings.alertsNewsletters.cancel')}`"
    @ok="saveBranchRule"
  >
    <new-rule-branch :branchData="branchData" />
  </b-modal>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import swal from 'sweetalert';
import newRuleBranch from '../../organisms/settings/settings-alert-rules/new-rule/tab-geral';
import api from '../../../services/api';

export default {
  props: ['branchData', 'mainRuleId', 'page', 'filter'],

  computed: {
    ...mapFields('alertRules', ['newRule']),
  },

  data: () => ({
    userAuth: null,
  }),

  components: {
    newRuleBranch,
  },

  methods: {
    ...mapActions('alertRules', ['getBranchRules']),
    clearNewRulevariale() {
      this.newRule = {
        name: null,
        rules: [
          {
            email: null,
            justComment: false,
            alerts: [
              { grade: 0, value: false },
              { grade: 1, value: false },
              { grade: 2, value: false },
              { grade: 3, value: false },
              { grade: 4, value: false },
              { grade: 5, value: false },
              { grade: 6, value: false },
              { grade: 7, value: false },
              { grade: 8, value: false },
              { grade: 9, value: false },
              { grade: 10, value: false },
            ],
          },
        ],
        level1: {
          email: null,
          days: null,
        },
        level2: {
          email: null,
          days: null,
        },
        level3: {
          email: null,
          days: null,
        },
      };
    },

    async mounted() {
      await this.getBranchRules({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        mainRuleId: this.mainRuleId,
        params: {
          limit: 10,
          page: this.page,
          filter: this.filter,
        },
      });
    },

    async saveBranchRule() {
      try {
        await api.post(
          `${process.env.API_ROOT}/branch-alert-rules/${this.userAuth.companyId}/${this.mainRuleId}/${this.branchData.branchId}`,
          { ...this.newRule },
          {
            headers: { 'x-access-token': this.userAuth.token },
          },
        );

        await swal({
          title: this.$t(
            'menu.settings.accountData.messages.saveBranchRuleSuccess.title',
          ),
          text: this.$t(
            'menu.settings.accountData.messages.saveBranchRuleSuccess.description',
            {
              branchDataName: `${this.branchData.name}`,
            },
          ),
          icon: 'success',
        });

        await this.getBranchRules({
          companyId: this.userAuth.companyId,
          token: this.userAuth.token,
          mainRuleId: this.mainRuleId,
          params: {
            limit: 10,
            page: this.page,
            filter: this.filter,
          },
        });

        this.clearNewRulevariale();
      } catch (error) {
        await swal({
          title: this.$t(
            'menu.settings.accountData.messages.saveBranchRuleError.title',
          ),
          text: this.$t(
            'menu.settings.accountData.messages.saveBranchRuleError.description',
          ),
          icon: 'warning',
        });
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.clearNewRulevariale();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/molecules/modal-alert-rule-branch/index.vue